import { ClientTheme } from '../types/theme.types';
import defaultTheme from '../themes/default/theme.json';
import cementosTheme from '../themes/cementos/theme.json';
import innovaTheme from '../themes/innova/theme.json';
import casfogTheme from '../themes/casfog/theme.json';
import atlanticCapitalTheme from '../themes/atlantic-capital/theme.json';
import acaTheme from '../themes/aca/theme.json';

/**
 * Registry de perfiles de diseño por cliente
 * Los temas se importan estáticamente para garantizar que webpack los incluya en el bundle
 */
class ThemeRegistry {
  private themes: Map<string, ClientTheme>;

  constructor() {
    // Registro estático de todos los temas disponibles
    this.themes = new Map<string, ClientTheme>([
      ['default', defaultTheme as ClientTheme],
      ['cementos', cementosTheme as ClientTheme],
      ['innova', innovaTheme as ClientTheme],
      ['casfog', casfogTheme as ClientTheme],
      ['atlantic-capital', atlanticCapitalTheme as ClientTheme],
      ['aca', acaTheme as ClientTheme],
      // Agregar más clientes aquí:
      // ['nuevo-cliente', nuevoClienteTheme as ClientTheme],
    ]);
  }

  /**
   * Obtiene el perfil de diseño para un cliente específico
   * @param clientName - Nombre del cliente (debe coincidir con la key en el registro)
   * @returns El tema del cliente o null si no existe
   */
  getTheme(clientName: string): ClientTheme | null {
    const theme = this.themes.get(clientName);
    
    if (!theme) {
      console.warn(`⚠️ No se encontró perfil de diseño para el cliente: "${clientName}"`);
      console.log('Clientes disponibles:', Array.from(this.themes.keys()).join(', '));
      return null;
    }

    console.log(`✅ Perfil de diseño encontrado: "${theme.name}" (${clientName})`);
    return theme;
  }

  /**
   * Obtiene todos los clientes registrados
   */
  getAvailableClients(): string[] {
    return Array.from(this.themes.keys());
  }
}

export const themeRegistry = new ThemeRegistry();
